import { useState } from "react";

import { Popover } from "antd";

import { ToolbarButton } from "components/base";
import { Radius_Icon } from "components/icons";

import XdaRadiusOptions from "./XdaRadiusOptions";

function XdaRadiusToggle() {
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      content={<XdaRadiusOptions />}
      open={visible}
      onOpenChange={(v) => setVisible(v)}
      trigger="click"
      placement="bottomRight">
      <ToolbarButton
        icon={<Radius_Icon />}
        isMenuButton={true}
        active={false}
        overflowLabel={"Radius"}
        tooltipText={"Radius Options"}
        data-testid="xda-radius-toggle"
        styleKey="xdaToolbar"
      />
    </Popover>
  );
}

export default XdaRadiusToggle;
